<!--
 * @Author: Junchi Zhao
 * @LastEditors: Junchi Zhao
 * @Description: 溯源查询
-->
<template>
  <div class="sy">
    <div class="title">
      <div class="line"></div>
      <div class="name">草原羊追溯查询系统</div>
      <div class="line"></div>
    </div>
    <div class="input">
      <el-input class="search" maxlength="24" v-model="code" type="text">
        <div slot="suffix" class="df aic pcth100">
          <div class="searchBtn" @click="doGetBatchID">搜索</div>
        </div>
      </el-input>
    </div>
  </div>
</template>

<script>
export default {
  name: "sy",
  components: {
    info: () => import("./info/index.vue")
  },

  data() {
    return {
      code: "",
      show: false,
      show1: false,
      isPermission: false
    };
  },

  computed: {},

  created() {},

  methods: {
    //这里增加一个接口进行判断
    doGetBatchID() {
      let code = this.code;
      this.$api
        .formPost("/api/major/breed/batch/marks/doGetByBatchId", {
          code: code
        })
        .then(res => {
          if (res.retHead.code == "0000000") {
            if (res.retBody) {
              this.show1 = false;
              let batchInfo = JSON.stringify(res.retBody);
              //该批次相关信息放session
              sessionStorage.setItem("batchInfo", batchInfo);
              sessionStorage.setItem("code", code);

              this.$router.push({
                path: "/syInfo",
                query: {
                  code: this.code
                }
              });
            } else {
              Toast(res.retHead.message);
            }
          } else {
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.sy {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: url("../../assets/images/sy/syHome.jpeg");
  background-repeat: no-repeat;
  background-size: 100%;
  .title {
    display: flex;
    align-items: center;

    .line {
      height: 1px;
      background: #d3d3d3;
      width: 7.969vw;
    }

    .name {
      margin: 0px 35px;
      font-size: 32px;
      font-weight: bold;
      color: #ffffff;
    }
  }

  .input {
    margin-top: 3.646vw;

    .searchBtn {
      height: 5.208vw;
      line-height: 5.208vw;
      width: 10.417vw;
      background: #449b4f;
      border-radius: 2.604vw;
      font-size: 1.25vw;
      margin-right: 0.26vw;
      color: #fff;
      cursor: pointer;
    }
  }
}

/deep/ .search .el-input__inner {
  height: 6.25vw;
  width: 57.292vw;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 3.646vw;
  font-size: 32px;
  color: #555;
  padding-left: 40px;
}

/deep/ .el-input__inner:focus {
  border-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/pages/sy/index.vue